import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import registerReducer from '../features/register-supplier/registerSupplierSlice';
import notificationMessageReducer from '../features/notification-message/notificationMessageSlice';

export default configureStore({
  reducer: {
    counter: counterReducer,
    registerSupplier: registerReducer,
    notificationMessage: notificationMessageReducer,
  },
});
